import { useEffect } from "react";

import { redondearDecimales } from "../../../utils/utils_number.js";

const useResumenCCF = ({ setFacturaItems, facturaItems, tercero, itemsPrecargados, setResumen, formaPago }) => {
  const calcularFacturaResumen = () => {
    let totalNoSuj = 0,
      totalExenta = 0,
      totalGravada = 0,
      ivaRete1 = 0;
    let tributosMap = new Map();

    facturaItems.forEach(({ ventaNoSuj = 0, ventaExenta = 0, ventaGravada = 0, tributos = [] }) => {
      ventaGravada = +ventaGravada.toFixed(2);
      ventaExenta = +ventaExenta.toFixed(2);
      ventaNoSuj = +ventaNoSuj.toFixed(2);

      totalNoSuj += ventaNoSuj;
      totalExenta += ventaExenta;
      totalGravada += ventaGravada;

      tributos?.forEach((cod) => {
        const valorTributo = +(ventaGravada * 0.13).toFixed(2); // Suponiendo que el tributo es IVA al 13%
        tributosMap.set(cod, (tributosMap.get(cod) || 0) + valorTributo);
      });
    });

    const tributos = Array.from(tributosMap, ([codigo, valor]) => ({
      codigo,
      descripcion: obtenerDescripcionTributo(codigo),
      valor: redondearDecimales(valor),
    }));

    if (tercero?.agente_retencion && totalGravada >= 100) {
      ivaRete1 = redondearDecimales(totalGravada * 0.01, 2);
    }

    setResumen({
      totalNoSuj: redondearDecimales(totalNoSuj, 2),
      totalExenta: redondearDecimales(totalExenta, 2),
      totalGravada: redondearDecimales(totalGravada, 2),
      tributos,
      ivaRete1,
      formaPago,
    });
  };

  const obtenerDescripcionTributo = (codigo) =>
    ({
      20: "Impuesto al Valor Agregado 13%",
      C3: "IVA (exportaciones) 0%",
    }[codigo] || "Otro tributo");

  useEffect(() => {
    if (itemsPrecargados?.length > 0) {
      setFacturaItems(itemsPrecargados);
    }
  }, [itemsPrecargados]);

  return { calcularFacturaResumen };
};

export default useResumenCCF;
